import React from "react";
import "./Hero.scss";
import heroImage from "../../assets/images/hero_image_1.webp";

const Hero = () => {
    return (
        <section className="hero">
            <div className="hero__content">
                <h1>We Build. We Connect. We Innovate.</h1>
            </div>
            <div className="hero__images">
                <img src={heroImage} alt="TechADive Showcase" />
            </div>
        </section>
    );
};

export default Hero;
